import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughMessengerUrlRoutingProps = {
  node: ConversationFlowAuditLogEntry<'MESSENGER_URL_ROUTING_NODE_VISITED'>;
};

export function RoutedThroughMessengerUrlRouting({
  node,
}: RoutedThroughMessengerUrlRoutingProps): JSX.Element {
  return (
    <>
      Url Trigger ·{' '}
      {node.match_value && (
        <>
          Routed via <strong>{node.match_value}</strong>
        </>
      )}
    </>
  );
}
